import { render, staticRenderFns } from "./TenantEdit.vue?vue&type=template&id=ab92b212&scoped=true&"
import script from "./TenantEdit.vue?vue&type=script&lang=js&"
export * from "./TenantEdit.vue?vue&type=script&lang=js&"
import style0 from "./TenantEdit.vue?vue&type=style&index=0&id=ab92b212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab92b212",
  null
  
)

export default component.exports